import { getCreate2Address } from '@ethersproject/address'
import { keccak256, pack } from '@ethersproject/solidity'
import { bscBaseTokens, chainData, polygonBaseTokens } from '@jdiyield/constants'
import { AnotherToken, Token as CoinToken } from '@jdiyield/interfaces'

// TODO: add base coin for other chain
export const BASES_TO_TRACK_LIQUIDITY_FOR: Record<number, CoinToken[]> = {
  56: Object.values(bscBaseTokens),
  97: [],
  137: Object.values(polygonBaseTokens)
}

const PAIR_ADDRESS_CACHE = {}
export const getLPAddress = (
  tokenA: AnotherToken,
  tokenB: AnotherToken,
  factoryAddress: string,
  initCodeHash: string
) => {
  try {
    const tokens = sortToken(tokenA, tokenB) ? [tokenA, tokenB] : [tokenB, tokenA] // does safety checks

    if (PAIR_ADDRESS_CACHE?.[factoryAddress]?.[tokens[0].address]?.[tokens[1].address] === undefined) {
      PAIR_ADDRESS_CACHE[factoryAddress] = {
        ...PAIR_ADDRESS_CACHE[factoryAddress],
        [tokens[0].address]: {
          ...PAIR_ADDRESS_CACHE?.[factoryAddress]?.[tokens[0].address],
          [tokens[1].address]: getCreate2Address(
            factoryAddress,
            keccak256(['bytes'], [pack(['address', 'address'], [tokens[0].address, tokens[1].address])]),
            initCodeHash
          )
        }
      }
    }

    return PAIR_ADDRESS_CACHE[factoryAddress][tokens[0].address][tokens[1].address]
  } catch {
    return null
  }
}

function sortToken(tokenA: AnotherToken, tokenB: AnotherToken): boolean {
  return tokenA.address.toLowerCase() < tokenB.address.toLowerCase()
}

function pairBetweenToken(tokenList): CoinToken[] {
  // dedupes pairs of tokens in list
  const keyed = tokenList.reduce((memo, [tokenA, tokenB]) => {
    const sorted = sortToken(tokenA, tokenB)
    const key = sorted ? `${tokenA.address}:${tokenB.address}` : `${tokenB.address}:${tokenA.address}`
    if (memo[key]) return memo
    memo[key] = sorted ? [tokenA, tokenB] : [tokenB, tokenA]
    return memo
  }, {})
  return Object.keys(keyed).map((key) => keyed[key])
}

// pairs for every token against every base
export const generatedPairs = (
  chainId: number,
  tokenList: CoinToken[],
  extendTokens: CoinToken[] = []
): CoinToken[] => {
  const tokenListFiltterd = tokenList.filter((token) => token.chain === chainData[chainId].chainName)
  const generateList =
    tokenListFiltterd.flatMap((token) => {
      // for each token on the current chain,
      const baseTokens = BASES_TO_TRACK_LIQUIDITY_FOR[chainId] ?? []
      return (
        // loop though all bases on the current chain
        ([...baseTokens, ...extendTokens] ?? [])
          // to construct pairs of the given token with each base
          .map((base) => {
            if (base.address === token.address) {
              return null
            }
            return [base, token]
          })
          .filter((p) => p !== null)
      )
    }) ?? []

  return pairBetweenToken(generateList)
}
